/// <amd-module name="SuiteCommerce.LookBook.LookItem.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.LookItem.Collection", ["require", "exports", "underscore", "Backbone.CachedCollection", "SuiteCommerce.LookBook.Common.Utils", "SuiteCommerce.LookBook.LookItem.Model"], function (require, exports, _, BackboneCachedCollection, Utils_1, LookItem_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookItemCollection = void 0;
    var LookItemCollection = /** @class */ (function (_super) {
        __extends(LookItemCollection, _super);
        function LookItemCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.url = Utils_1.Utils.getAbsoluteUrl(getExtensionAssetsPath('services/LookItem.Service.ss'));
            _this.model = LookItem_Model_1.LookItemModel;
            return _this;
        }
        LookItemCollection.prototype.parse = function (items) {
            var parseToLookItemModel = _.map(items, function (item) {
                return new LookItem_Model_1.LookItemModel(item);
            });
            return parseToLookItemModel;
        };
        return LookItemCollection;
    }(BackboneCachedCollection));
    exports.LookItemCollection = LookItemCollection;
});
